<template>
    <default-field :errors="errors" :title="title">
        <template v-slot:field="slotProps">
            <ckeditor
                v-bind="$attrs"
                v-on:input="setValue"
                :editor="editor"
                :config="editorConfig"
            />
        </template>
    </default-field>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DefaultField from "./DefaultField";

export default {
    inheritAttrs: false,

    components: {
        DefaultField
    },

    props: {
        errors: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                extraPlugins: [this.CustomUploadAdapter]
            }
        };
    },

    methods: {
        CustomUploadAdapter(editor) {
            editor.plugins.get(
                "FileRepository"
            ).createUploadAdapter = loader => {
                return new CustomUploadAdapter(loader);
            };
        },

        setValue(value) {
            this.$emit("input", value);
        }
    }
};

class CustomUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(
            uploadedFile =>
                new Promise((resolve, reject) => {
                    const data = new FormData();
                    data.append("file", uploadedFile);

                    axios
                        .post("upload", data, {
                            "Content-Type": "multipart/form-data;"
                        })
                        .then(response => {
                            resolve({
                                default: response.data.url
                            });
                        })
                        .catch(response => {
                            reject("Upload failed");
                        });
                })
        );
    }

    abort() {
        //
    }
}
</script>